import onetime from "@-/com.npmjs.onetime";
import pinyinRawData from "@-/dev.improve.haniverse.assets.pinyin.data";
import { pinyinDataSchema } from "#pinyin-data-schema";
import {
  isPinyinSyllableEntry,
  isPinyinToneEntry,
  isPinyinToneKey,
  type PinyinData,
} from "#pinyin-data";

function filterDonePinyinSyllables(data: PinyinData): PinyinData {
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion -- built incrementally; shape validated by assignments below
  const filtered = {} as PinyinData;

  for (const key of Reflect.ownKeys(data)) {
    if (typeof key !== "string") {
      continue;
    }
    const entry = data[key];
    if (isPinyinToneKey(key)) {
      if (isPinyinToneEntry(entry)) {
        filtered[key] = entry;
      }
      continue;
    }
    if (!isPinyinSyllableEntry(entry) || entry.done !== true) {
      continue;
    }
    const { done: _done, ...syllable } = entry;
    filtered[key] = syllable;
  }

  return filtered;
}

export const getPinyinData = onetime((): PinyinData =>
  filterDonePinyinSyllables(pinyinDataSchema.parse(pinyinRawData)),
);
